export function isSpace(code: number): boolean {
  // codepoints with property Whitespace
  switch (code >> 16) {
    case 0x00:
      switch (code) {
        default:
          return false;
        case 0x09:
          return true; // CHARACTER TABULATION
        case 0x0a:
          return true; // LINE FEED
        case 0x0b:
          return true; // LINE TABULATION
        case 0x0c:
          return true; // FORM FEED
        case 0x0d:
          return true; // CARRIAGE RETURN
        case 0x20:
          return true; // SPACE
        case 0x85:
          return true; // NEXT LINE
        case 0xa0:
          return true; // NO-BREAK SPACE
      }
    case 0x20:
      code &= 0xff;
      if (code <= 0x0a) {
        return true; // EN QUAD..HAIR SPACE
      }
      switch (code) {
        default:
          return false;
        case 0x28:
          return true; // LINE SEPARATOR
        case 0x29:
          return true; // PARAGRAPH SEPARATOR
        case 0x2f:
          return true; // NARROW NO-BREAK SPACE
        case 0x5f:
          return true; // MEDIUM MATHEMATICAL SPACE
      }
    default:
      switch (code) {
        default:
          return false;
        case 0x1680:
          return true; // OGHAM SPACE MARK
        case 0x180e:
          return true; // MONGOLIAN VOWEL SEPARATOR
        case 0x3000:
          return true; // IDEOGRAPHIC SPACE
      }
  }
}

export function isWord(code: number) {
  // Binary search in letters table.
  let s = 0;
  let e = letters.length >> 1;
  while (s !== e) {
    const m = (s + e) >> 1;
    const first = letters[m << 1];
    if (code < first) {
      e = m;
      continue;
    }
    const length = letters[(m << 1) | 1];
    if (code < first + length) {
      return true;
    }
    s = m + 1;
  }
  return false;
}

// Spans of code points with the letter property: first code and length
// prettier-ignore
const letters = [
  0x30,
  10,
  0x41,
  26,
  0x61,
  26,
  0xaa,
  1,
  0xb2,
  2,
  0xb5,
  1,
  0xb9,
  2,
  0xbc,
  3,
  0xc0,
  23,
  0xd8,
  31,
  0xf8,
  458,
  0x2c6,
  12,
  0x2e0,
  5,
  0x2ec,
  1,
  0x2ee,
  1,
  0x370,
  5,
  0x376,
  2,
  0x37a,
  4,
  0x386,
  1,
  0x388,
  3,
  0x38c,
  1,
  0x38e,
  20,
  0x3a3,
  83,
  0x3f7,
  139,
  0x48a,
  156,
  0x531,
  38,
  0x559,
  1,
  0x561,
  39,
  0x5d0,
  27,
  0x5f0,
  3,
  0x621,
  42,
  0x660,
  10,
  0x66e,
  2,
  0x671,
  99,
  0x6d5,
  1,
  0x6e5,
  2,
  0x6ee,
  15,
  0x6ff,
  1,
  0x710,
  1,
  0x712,
  30,
  0x74d,
  89,
  0x7b1,
  1,
  0x7c0,
  43,
  0x7f4,
  2,
  0x7fa,
  1,
  0x800,
  22,
  0x81a,
  1,
  0x824,
  1,
  0x828,
  1,
  0x904,
  54,
  0x93d,
  1,
  0x950,
  1,
  0x958,
  10,
  0x966,
  10,
  0x971,
  2,
  0x979,
  7,
  0x985,
  8,
  0x98f,
  2,
  0x993,
  22,
  0x9aa,
  7,
  0x9b2,
  1,
  0x9b6,
  4,
  0x9bd,
  1,
  0x9ce,
  1,
  0x9dc,
  2,
  0x9df,
  3,
  0x9e6,
  12,
  0x9f4,
  6,
  0xa05,
  6,
  0xa0f,
  2,
  0xa13,
  22,
  0xa2a,
  7,
  0xa32,
  2,
  0xa35,
  2,
  0xa38,
  2,
  0xa59,
  4,
  0xa5e,
  1,
  0xa66,
  10,
  0xa72,
  3,
  0xa85,
  9,
  0xa8f,
  3,
  0xa93,
  22,
  0xaaa,
  7,
  0xab2,
  2,
  0xab5,
  5,
  0xabd,
  1,
  0xad0,
  1,
  0xae0,
  2,
  0xae6,
  10,
  0xb05,
  8,
  0xb0f,
  2,
  0xb13,
  22,
  0xb2a,
  7,
  0xb32,
  2,
  0xb35,
  5,
  0xb3d,
  1,
  0xb5c,
  2,
  0xb5f,
  3,
  0xb66,
  10,
  0xb71,
  1,
  0xb83,
  1,
  0xb85,
  6,
  0xb8e,
  3,
  0xb92,
  4,
  0xb99,
  2,
  0xb9c,
  1,
  0xb9e,
  2,
  0xba3,
  2,
  0xba8,
  3,
  0xbae,
  12,
  0xbd0,
  1,
  0xbe6,
  13,
  0xc05,
  8,
  0xc0e,
  3,
  0xc12,
  23,
  0xc2a,
  10,
  0xc35,
  5,
  0xc3d,
  1,
  0xc58,
  2,
  0xc60,
  2,
  0xc66,
  10,
  0xc78,
  7,
  0xc85,
  8,
  0xc8e,
  3,
  0xc92,
  23,
  0xcaa,
  10,
  0xcb5,
  5,
  0xcbd,
  1,
  0xcde,
  1,
  0xce0,
  2,
  0xce6,
  10,
  0xd05,
  8,
  0xd0e,
  3,
  0xd12,
  23,
  0xd2a,
  16,
  0xd3d,
  1,
  0xd60,
  2,
  0xd66,
  16,
  0xd7a,
  6,
  0xd85,
  18,
  0xd9a,
  24,
  0xdb3,
  9,
  0xdbd,
  1,
  0xdc0,
  7,
  0xe01,
  48,
  0xe32,
  2,
  0xe40,
  7,
  0xe50,
  10,
  0xe81,
  2,
  0xe84,
  1,
  0xe87,
  2,
  0xe8a,
  1,
  0xe8d,
  1,
  0xe94,
  4,
  0xe99,
  7,
  0xea1,
  3,
  0xea5,
  1,
  0xea7,
  1,
  0xeaa,
  2,
  0xead,
  4,
  0xeb2,
  2,
  0xebd,
  1,
  0xec0,
  5,
  0xec6,
  1,
  0xed0,
  10,
  0xedc,
  2,
  0xf00,
  1,
  0xf20,
  20,
  0xf40,
  8,
  0xf49,
  36,
  0xf88,
  4,
  0x1000,
  43,
  0x103f,
  11,
  0x1050,
  6,
  0x105a,
  4,
  0x1061,
  1,
  0x1065,
  2,
  0x106e,
  3,
  0x1075,
  13,
  0x108e,
  1,
  0x1090,
  10,
  0x10a0,
  38,
  0x10d0,
  43,
  0x10fc,
  1,
  0x1100,
  329,
  0x124a,
  4,
  0x1250,
  7,
  0x1258,
  1,
  0x125a,
  4,
  0x1260,
  41,
  0x128a,
  4,
  0x1290,
  33,
  0x12b2,
  4,
  0x12b8,
  7,
  0x12c0,
  1,
  0x12c2,
  4,
  0x12c8,
  15,
  0x12d8,
  57,
  0x1312,
  4,
  0x1318,
  67,
  0x1369,
  20,
  0x1380,
  16,
  0x13a0,
  85,
  0x1401,
  620,
  0x166f,
  17,
  0x1681,
  26,
  0x16a0,
  75,
  0x16ee,
  3,
  0x1700,
  13,
  0x170e,
  4,
  0x1720,
  18,
  0x1740,
  18,
  0x1760,
  13,
  0x176e,
  3,
  0x1780,
  52,
  0x17d7,
  1,
  0x17dc,
  1,
  0x17e0,
  10,
  0x17f0,
  10,
  0x1810,
  10,
  0x1820,
  88,
  0x1880,
  41,
  0x18aa,
  1,
  0x18b0,
  70,
  0x1900,
  29,
  0x1946,
  40,
  0x1970,
  5,
  0x1980,
  44,
  0x19c1,
  7,
  0x19d0,
  11,
  0x1a00,
  23,
  0x1a20,
  53,
  0x1a80,
  10,
  0x1a90,
  10,
  0x1aa7,
  1,
  0x1b05,
  47,
  0x1b45,
  7,
  0x1b50,
  10,
  0x1b83,
  30,
  0x1bae,
  12,
  0x1c00,
  36,
  0x1c40,
  10,
  0x1c4d,
  49,
  0x1ce9,
  4,
  0x1cee,
  4,
  0x1d00,
  192,
  0x1e00,
  278,
  0x1f18,
  6,
  0x1f20,
  38,
  0x1f48,
  6,
  0x1f50,
  8,
  0x1f59,
  1,
  0x1f5b,
  1,
  0x1f5d,
  1,
  0x1f5f,
  31,
  0x1f80,
  53,
  0x1fb6,
  7,
  0x1fbe,
  1,
  0x1fc2,
  3,
  0x1fc6,
  7,
  0x1fd0,
  4,
  0x1fd6,
  6,
  0x1fe0,
  13,
  0x1ff2,
  3,
  0x1ff6,
  7,
  0x2070,
  2,
  0x2074,
  6,
  0x207f,
  11,
  0x2090,
  5,
  0x2102,
  1,
  0x2107,
  1,
  0x210a,
  10,
  0x2115,
  1,
  0x2119,
  5,
  0x2124,
  1,
  0x2126,
  1,
  0x2128,
  1,
  0x212a,
  4,
  0x212f,
  11,
  0x213c,
  4,
  0x2145,
  5,
  0x214e,
  1,
  0x2150,
  58,
  0x2460,
  60,
  0x24ea,
  22,
  0x2776,
  30,
  0x2c00,
  47,
  0x2c30,
  47,
  0x2c60,
  133,
  0x2ceb,
  4,
  0x2cfd,
  1,
  0x2d00,
  38,
  0x2d30,
  54,
  0x2d6f,
  1,
  0x2d80,
  23,
  0x2da0,
  7,
  0x2da8,
  7,
  0x2db0,
  7,
  0x2db8,
  7,
  0x2dc0,
  7,
  0x2dc8,
  7,
  0x2dd0,
  7,
  0x2dd8,
  7,
  0x2e2f,
  1,
  0x3005,
  3,
  0x3021,
  9,
  0x3031,
  5,
  0x3038,
  5,
  0x3041,
  86,
  0x309d,
  3,
  0x30a1,
  90,
  0x30fc,
  4,
  0x3105,
  41,
  0x3131,
  94,
  0x3192,
  4,
  0x31a0,
  24,
  0x31f0,
  16,
  0x3220,
  10,
  0x3251,
  15,
  0x3280,
  10,
  0x32b1,
  15,
  0x3400,
  6581,
  0x4e00,
  20939,
  0xa000,
  1165,
  0xa4d0,
  46,
  0xa500,
  269,
  0xa610,
  28,
  0xa640,
  32,
  0xa662,
  13,
  0xa67f,
  25,
  0xa6a0,
  80,
  0xa717,
  9,
  0xa722,
  103,
  0xa78b,
  2,
  0xa7fb,
  7,
  0xa803,
  3,
  0xa807,
  4,
  0xa80c,
  23,
  0xa830,
  6,
  0xa840,
  52,
  0xa882,
  50,
  0xa8d0,
  10,
  0xa8f2,
  6,
  0xa8fb,
  1,
  0xa900,
  38,
  0xa930,
  23,
  0xa960,
  29,
  0xa984,
  47,
  0xa9cf,
  11,
  0xaa00,
  41,
  0xaa40,
  3,
  0xaa44,
  8,
  0xaa50,
  10,
  0xaa60,
  23,
  0xaa7a,
  1,
  0xaa80,
  48,
  0xaab1,
  1,
  0xaab5,
  2,
  0xaab9,
  5,
  0xaac0,
  1,
  0xaac2,
  1,
  0xaadb,
  3,
  0xabc0,
  35,
  0xabf0,
  10,
  0xac00,
  11171,
  0xd7b0,
  23,
  0xd7cb,
  49,
  0xf900,
  302,
  0xfa30,
  62,
  0xfa70,
  106,
  0xfb00,
  7,
  0xfb13,
  5,
  0xfb1d,
  1,
  0xfb1f,
  10,
  0xfb2a,
  13,
  0xfb38,
  5,
  0xfb3e,
  1,
  0xfb40,
  2,
  0xfb43,
  2,
  0xfb46,
  108,
  0xfbd3,
  363,
  0xfd50,
  64,
  0xfd92,
  54,
  0xfdf0,
  12,
  0xfe70,
  5,
  0xfe76,
  135,
  0xff10,
  10,
  0xff21,
  26,
  0xff41,
  26,
  0xff66,
  89,
  0xffc2,
  6,
  0xffca,
  6,
  0xffd2,
  6,
  0xffda,
  3,
  0x10000,
  12,
  0x1000d,
  26,
  0x10028,
  19,
  0x1003c,
  2,
  0x1003f,
  15,
  0x10050,
  14,
  0x10080,
  123,
  0x10107,
  45,
  0x10140,
  57,
  0x1018a,
  1,
  0x10280,
  29,
  0x102a0,
  49,
  0x10300,
  31,
  0x10320,
  4,
  0x10330,
  27,
  0x10380,
  30,
  0x103a0,
  36,
  0x103c8,
  8,
  0x103d1,
  5,
  0x10400,
  158,
  0x104a0,
  10,
  0x10800,
  6,
  0x10808,
  1,
  0x1080a,
  44,
  0x10837,
  2,
  0x1083c,
  1,
  0x1083f,
  23,
  0x10858,
  8,
  0x10900,
  28,
  0x10920,
  26,
  0x10a00,
  1,
  0x10a10,
  4,
  0x10a15,
  3,
  0x10a19,
  27,
  0x10a40,
  8,
  0x10a60,
  31,
  0x10b00,
  54,
  0x10b40,
  22,
  0x10b58,
  27,
  0x10b78,
  8,
  0x10c00,
  73,
  0x10e60,
  31,
  0x11083,
  45,
  0x12000,
  879,
  0x12400,
  99,
  0x13000,
  1071,
  0x1d360,
  18,
  0x1d400,
  85,
  0x1d456,
  71,
  0x1d49e,
  2,
  0x1d4a2,
  1,
  0x1d4a5,
  2,
  0x1d4a9,
  4,
  0x1d4ae,
  12,
  0x1d4bb,
  1,
  0x1d4bd,
  7,
  0x1d4c5,
  65,
  0x1d507,
  4,
  0x1d50d,
  8,
  0x1d516,
  7,
  0x1d51e,
  28,
  0x1d53b,
  4,
  0x1d540,
  5,
  0x1d546,
  1,
  0x1d54a,
  7,
  0x1d552,
  340,
  0x1d6a8,
  25,
  0x1d6c2,
  25,
  0x1d6dc,
  31,
  0x1d6fc,
  25,
  0x1d716,
  31,
  0x1d736,
  25,
  0x1d750,
  31,
  0x1d770,
  25,
  0x1d78a,
  31,
  0x1d7aa,
  25,
  0x1d7c4,
  8,
  0x1d7ce,
  50,
  0x1f100,
  11,
  0x20000,
  42710,
  0x2a700,
  4148,
  0x2f800,
  542,
];
